import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import LazyBackground from "../../partials/LazyBackground";
import "./Section5.scss";

const services = [
  {
    id: "01",
    title: "AI Solutions",
    img: "ai.webp",
    desc:
      "Automate processes, uncover insights, and enable smarter decisions using AI-driven systems and predictive analytics.",
  },
  {
    id: "02",
    title: "Resource Augmentation",
    img: "resource-augmentation.jpg",
    desc:
      "Access skilled developers, engineers, and AI specialists on demand to scale teams without long-term hiring overhead.",
  },
  {
    id: "03",
    title: "Design & Development",
    img: "app-web-dev.webp",
    desc:
      "Create intuitive websites, mobile apps, and digital platforms that align with user needs and business goals.",
  },
  {
    id: "04",
    title: "Branding",
    img: "branding.webp",
    desc:
      "Build visibility, generate leads, and grow digital presence through data-driven marketing and brand strategies.",
  },
];

const Section5 = ({ url }) => {
  const [active, setActive] = useState(null);
  const [showText, setShowText] = useState(false);

  const handleHover = (i) => {
  setActive(i);               // expand the column
  setShowText(false);         // hide text instantly

  setTimeout(() => {
    setShowText(true);        // reveal text after animation delay
  }, 550);                    // matches CSS expand duration
};

const handleLeave = () => {
  setActive(null);
  setShowText(false);
};

  return (
    <section className="home-section-5">

      {/* ===========================
          DESKTOP VERSION
      ============================= */}
      <div className="main-div">
        <div className="parentBox">
          {services.map((s, i) => (
            <LazyBackground
              key={i}
              className={`image-column ${
                active === i ? "active" : active !== null ? "shrink" : ""
              }`}
              src={`${url}images/homepage/${s.img}`}
              gradient="linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.6))"
              style={{}} // any extra styles
              onMouseEnter={() => handleHover(i)}
              onMouseLeave={handleLeave}
            >
              
            {/* Only render full content when active */}
           
                  <div className="overlay">

                    {
                      (active === null || active !== i) && (
                        <>
                          <>
                            <h2 className="h2-default">{s.id}</h2>
                            <p className="title-default">{s.title}</p>
                          </>
                          <>
                            <Link className="descp-link-default" to="/services">
                              <FontAwesomeIcon icon={faArrowRightLong} className="i" />
                            </Link>
                          </>
                        </>
                      )
                    }

                    {active === i && (
                      <>
                      <h2 className={active === i && showText ? "show" : ""}>{s.id}</h2>

                      <p className={`title ${active === i && showText ? "show" : ""}`}>
                        {s.title}
                      </p>
                      <p className={`desc ${active === i && showText ? "show" : ""}`}>
                        {s.desc}
                      </p>

                    <Link to="/services" className={`descp-link ${active === i && showText ? "show" : ""}`}>
                      <FontAwesomeIcon icon={faArrowRightLong} className="i" />
                    </Link>
                    </>
                    )}
                  </div>
            </LazyBackground>
          ))}
        </div>
      </div>

      {/* ===========================
          TABLET VERSION
      ============================= */}
      <div className="main-div-2 container">
        {services.map((s, i) => (
          <div key={i} className="services-section">
            <div className="row services-section-row">

              <div className="col-lg-3 col-md-3 col-12 services-content-img">
                <img
                  loading="lazy"
                  src={`${url}images/homepage/${s.img}`}
                  alt={s.title}
                />
              </div>

              <div className="col-lg-9 col-md-9 col-12 services-content">
                <h2>{s.id}</h2>
                <p className="desc-title">{s.title}</p>
                <p className="field-desc">{s.desc}</p>

                <Link to="/services" className="desc-link">
                  <p className="desc-link-title">
                    View <FontAwesomeIcon icon={faArrowRightLong} className="i" />
                  </p>
                </Link>
              </div>

            </div>
          </div>
        ))}
      </div>

      {/* ===========================
          MOBILE VERSION
      ============================= */}
      <div className="main-div-3">
        <div className="container-section-5-3">
          {services.map((s, i) => (
            <div key={i} className="services-section">
                <LazyBackground
                  key={i}
                  className="bg-img"
                  src={`${url}images/homepage/${s.img}`}
                  gradient="linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,1))"
                  style={{}}
                >
                <h2>{s.id}</h2>
                <p className="desc-title">{s.title}</p>
                <p className="field-desc">{s.desc}</p>

                <Link to="/services" className="desc-link">
                  <p className="desc-link-title">
                    View <FontAwesomeIcon icon={faArrowRightLong} className="i" />
                  </p>
                </Link>
             </LazyBackground>

            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default Section5;
